export const filterNum = num => {
    if (!num) {
        return 0;
    }
    if (typeof num === 'object') {
        return '';
    }
    const cent = 2;
    num = num.toString().replace(/\$|\,/g, '');
    // 检查传入数值为数值类型
    if (isNaN(num)) {
        num = '0';
    }
    // 获取符号(正/负数)
    num = Math.floor(num * Math.pow(10, cent) + 0.50000000001); // 把指定的小数位先转换成整数.多余的小数位四舍五入
    num = Math.floor(num / Math.pow(10, cent)).toString(); // 求出整数位数值
    // 对整数部分进行千分位格式化.
    for (let i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
        num = `${num.substring(0, num.length - (4 * i + 3))},${num.substring(num.length - (4 * i + 3))}`;
    }
    return num;
}